import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  input,
  signal,
  TemplateRef,
} from '@angular/core';
import { generateId } from '@common';
import { AccordionPanelContentTemplateContext } from './models/accordion-panel-content-template-context.interface';
import { AccordionPanelHeaderTemplateContext } from './models/accordion-panel-header-template-context.interface';
import { AccordionPanelToggleEvent } from './models/accordion-panel-toggle-event.interface';
import { AccordionPanel } from './models/accordion-panel.interface';

@Component({
  selector: 'app-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  styleUrls: ['./accordion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet],
  standalone: true,
})
export class AccordionPanelComponent {
  accordionPanelHeaderTemplate =
    input<TemplateRef<AccordionPanelHeaderTemplateContext>>();
  accordionPanelContentTemplate =
    input<TemplateRef<AccordionPanelContentTemplateContext>>();
  body = input<string | undefined>();
  hasBorder = input<boolean>(false);
  panel = input<AccordionPanel | undefined>();
  title = input<string | undefined>();
  readonly expanded = input<boolean>(false);

  // Internal state
  expandedState = signal(this.expanded());
  id = generateId();
  toggle = new EventEmitter<AccordionPanelToggleEvent>();

  constructor() {
    effect(() => {
      this.expandedState.set(this.expanded());
    });
  }

  toggleExpanded(): void {
    const newExpandedValue = !this.expandedState();
    this.expandedState.set(newExpandedValue);
    this.toggle.emit({
      body: this.body() ?? this.panel()?.body,
      isExpanded: newExpandedValue,
      title: this.title() ?? this.panel()?.title,
    });
  }
}
